// (e.g., in src/redux/actions/types.js)
export const FETCH_AGENCIES_REQUEST = 'FETCH_AGENCIES_REQUEST';
export const FETCH_AGENCIES_SUCCESS = 'FETCH_AGENCIES_SUCCESS';
export const FETCH_AGENCIES_FAILURE = 'FETCH_AGENCIES_FAILURE';

export const SELECT_AGENCY = 'SELECT_AGENCY';

export const CONNECT_VEHICLE_SOCKET_SUCCESS = 'CONNECT_VEHICLE_SOCKET_SUCCESS';

export const UPDATE_VEHICLES = 'UPDATE_VEHICLES'; // Action for throttled updates

// EVP (Emergency Vehicle Preemption) related action types
export const UPDATE_EVP_VEHICLES = 'UPDATE_EVP_VEHICLES';
export const UPDATE_EVP_INCIDENTS = 'UPDATE_EVP_INCIDENTS';
export const UPDATE_EVP_PRIORITY = 'UPDATE_EVP_PRIORITY';
export const UPDATE_EVP_ROUTE_PREDICTION = 'UPDATE_EVP_ROUTE_PREDICTION';
export const CLEAR_EVP_ROUTE_PREDICTION = 'CLEAR_EVP_ROUTE_PREDICTION';

// Signal-related action types
export const CONNECT_SIGNAL_SOCKET_SUCCESS = 'CONNECT_SIGNAL_SOCKET_SUCCESS';
export const UPDATE_SIGNALS = 'UPDATE_SIGNALS'; // Action for throttled updates

// Priority (Traffic Signal Priority) related action types
export const CONNECT_PRIORITY_SOCKET_SUCCESS = 'CONNECT_PRIORITY_SOCKET_SUCCESS';
export const UPDATE_PRIORITY = 'UPDATE_PRIORITY'; // Action for throttled priority updates

// Signal Status (Pedestrian data for signals) related action types
export const CONNECT_SIGNAL_STATUS_SOCKET_SUCCESS = 'CONNECT_SIGNAL_STATUS_SOCKET_SUCCESS';

// Route-related action types
export const FETCH_ROUTES_REQUEST = 'FETCH_ROUTES_REQUEST';
export const FETCH_ROUTES_SUCCESS = 'FETCH_ROUTES_SUCCESS';
export const FETCH_ROUTES_FAILURE = 'FETCH_ROUTES_FAILURE';

export const FETCH_ROUTE_SIGNALS_REQUEST = 'FETCH_ROUTE_SIGNALS_REQUEST';
export const FETCH_ROUTE_SIGNALS_SUCCESS = 'FETCH_ROUTE_SIGNALS_SUCCESS';
export const FETCH_ROUTE_SIGNALS_FAILURE = 'FETCH_ROUTE_SIGNALS_FAILURE';

export const SELECT_ROUTES = 'SELECT_ROUTES';

export const FETCH_STOPS_REQUEST = 'FETCH_STOPS_REQUEST';
export const FETCH_STOPS_SUCCESS = 'FETCH_STOPS_SUCCESS';
export const FETCH_STOPS_FAILURE = 'FETCH_STOPS_FAILURE';

// Latency data actions
export const FETCH_LATENCY_REQUEST = 'FETCH_LATENCY_REQUEST';
export const FETCH_LATENCY_SUCCESS = 'FETCH_LATENCY_SUCCESS';
export const FETCH_LATENCY_FAILURE = 'FETCH_LATENCY_FAILURE';
export const UPDATE_LATENCY = 'UPDATE_LATENCY';
export const SET_LATENCY_ENABLED = 'SET_LATENCY_ENABLED';

// Combined batch update action for all entity types
export const BATCH_UPDATE_ALL_ENTITIES = 'BATCH_UPDATE_ALL_ENTITIES';